import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Acesso } from 'src/app/models/bas/acesso/acesso';
import { AuthService } from 'src/app/services/auth/auth.service';
import { AcessoService } from 'src/app/services/bas/acesso.service';
import { CustomSnackBarService } from 'src/app/shared/components/custom-snack-bar/custom-snack-bar.service';
import { Subject } from 'rxjs';
import { TrataExcessao } from '../../utils/trata-excessao';
import { ParametrosGenericos } from 'src/app/models/bas/parametros-genericos/parametros-genericos';
import { CadastroGenerico } from 'src/app/models/cad/cadastro-generico/cadastro-generico';
import { RelacaoGenericaService } from 'src/app/services/bas/relacao-generica.service';

@Component({
  selector: 'app-abstract-idba-component',
  template: ``,
  styles: [],
})
export class AbstractIdbaComponentComponent implements OnInit, OnDestroy {
  public programa: string;
  public isLoading = false;
  public countLoading = 0;
  public acesso: Acesso | undefined = undefined;
  public form: UntypedFormGroup;
  public destroy$ = new Subject<void>();
  public funcoes: any = {};
  public parametrosGenericos: ParametrosGenericos[] = [];
  public cadastrosGenericos: CadastroGenerico[] = [];
  public assuntosRelacoesGenericas: string[] = [];

  public relacaoGenericaService = inject(RelacaoGenericaService);


  constructor(
    public snackBar: CustomSnackBarService,
    public authService: AuthService,
    public acessoService: AcessoService,
  ) { this.acessoService.resetModel(); }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnInit() {
    this.consultaPermissaoAcesso();
  }

  public getGenericParams() {
    this.relacaoGenericaService.getRelacaoGenericaBySubjectList(this.assuntosRelacoesGenericas).then( () => {
      this.applyFunctions();
    });
  }

  applyFunctions(): void {

  }

  public exibirCarregando() {
    // Passou a ser feito via Interceptor
    // this.countLoading++;
    // this.isLoading = true;
  }

  public escondeCarregando(force: boolean = false) {
    // Passou a ser feito via Interceptor
    // this.countLoading--;
    // if (this.countLoading <= 0 || force) {
    //   this.isLoading = false;
    // }
  }

  public consultaPermissaoAcesso() { };

  public showMessage(msg: string, type: string = 'Success') {
    this.snackBar.openSnackBar(msg, null, type);
  }

  public verificaSeleciona(event, campo: string, campoCodigo: string) {
    if (event.srcElement.value === '') {
      this.form.controls[campo].setValue('');
      this.form.controls[campoCodigo].setValue(null);
    }
  }

  formatCurrencyToNumber(preco): number {
    if (typeof preco === 'string' || preco instanceof String) {
      preco = preco.replace("R$ ", "");
      preco = preco.replaceAll(".", "")
      preco = preco.replace(",", ".")
    }
    return parseFloat(preco)
  }

  public trataErro(err) {
    TrataExcessao.TrataExcessao(err, this.authService, this.snackBar);
  }

  formatNumberToCurrency(preco) {
    if (preco && (preco.toString().includes(".") || preco.toString().includes(",")) && !(preco.toString().includes(".") && preco.toString().includes(","))) {
      preco = preco.toString()
      const lastIndex = preco.lastIndexOf('.');

      const replacement = ',';

      preco =
        preco.substring(0, lastIndex) +
        replacement +
        preco.substring(lastIndex + 1);
      if (preco.substring(0, 1) === ",") {
        preco = preco.substring(1)
      }
    }
    return preco
  }

  pesquisaParamatroRelacaoLogico(assunto: string, nomeParametro: string, valorDefault: boolean) {
    var indAux = this.authService.getParametroRelacao(assunto, nomeParametro);
    if (indAux)
      return JSON.parse(indAux);
    else return valorDefault;
  }

  pesquisaParamatroRelacaoString(assunto: string, nomeParametro: string, valorDefault: string) {
    var aux = this.authService.getParametroRelacao(assunto, nomeParametro);
    if (aux) {
      return JSON.parse(aux).toString();
    }
    else return valorDefault;

  }



  public returnSelf() {
    return this;
  }

}
